/** H7 greybox start town D (เมืองโคมเก้าสาย, origin D): see townGrey.ts. */
import { townLayout, townZone } from './townGrey';

export const TOWN_D_LAYOUT = townLayout('town-d', 703);
export const TOWN_D_ZONE = townZone('town-d', 'เมืองโคมเก้าสาย', 703, [1.05, 1.0, 0.95]);
